import { returnTrueIfCellCanBeEdited } from "../../columnHelpers/cellCanBeEdited";

/**
 * Determine if the settlement date cell should show editable styling.
 */
export function isSettlementDateEditable(
  status: any,
  role: string | undefined,
): boolean {
  if (status == null) return false;
  if (role == "RP") {
    return false;
  }
  return returnTrueIfCellCanBeEdited(status);
}
